var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('maintenance-emergency-alert',{on:{"emergency-triggered":_vm.onEmergencyReceived}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }